import { Button, type ButtonProps } from 'antd';
import classnames from 'classnames';
import React, { memo } from 'react';
import { useMediaQuery } from 'react-responsive';

import { LEGACY_MAX_WIDTH_TABLET_MEDIUM } from 'style/constants';

import './styles.less';

// ==============================
// CONSTANTS & PURE FUNCTIONS
// ==============================
const mapTypeToAntdType = (type: Props['type']): ButtonProps['type'] => {
  switch (type) {
    case 'lets-go':
    case 'grey-primary':
      return 'primary';
    case 'default-black':
      return 'default';
    default:
      return type;
  }
};

// ==============================
// TYPES
// ==============================
interface Props
  extends Pick<
    ButtonProps,
    | 'id'
    | 'block'
    | 'children'
    | 'className'
    | 'danger'
    | 'disabled'
    | 'download'
    | 'href'
    | 'htmlType'
    | 'icon'
    | 'loading'
    | 'onClick'
    | 'rel'
    | 'size'
    | 'target'
  > {
  type?: ButtonProps['type'] | 'lets-go' | 'grey-primary' | 'default-black';
  mobileChildren?: string;
}

// ==============================
// COMPONENT
// ==============================
/**
 * A wrapper around the antd Button with our custom config applied.
 */
function DefaultButton({
  children,
  className,
  mobileChildren,
  type,
  ...rest
}: Props): JSX.Element {
  const isTabletOrMobile = useMediaQuery({ maxWidth: LEGACY_MAX_WIDTH_TABLET_MEDIUM });

  return (
    <Button
      {...rest}
      className={classnames('DefaultButton', {
        'black': type === 'default-black',
        'green': type === 'lets-go',
        'grey': type === 'grey-primary'
      }, className)}
      type={mapTypeToAntdType(type)}
    >
      {isTabletOrMobile && mobileChildren ? mobileChildren : children}
    </Button>
  );
}

export default memo(DefaultButton);
export type { Props as DefaultButtonProps };